import { ReactNode } from "react";
import { LuLoader } from "react-icons/lu";
import { clsxm } from "@/utils/clsxm";

interface IProps {
  label: string;
  loadingLabel?: string;
  iconRight?: ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

// Full-width primary CTA matching the SSN2 design: plum pill, 62px tall,
// 17px semibold, white, with a trailing icon.
const VerifyButton = ({
  label,
  loadingLabel,
  iconRight,
  isLoading = false,
  disabled = false,
  onClick,
}: IProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || isLoading}
      className={clsxm(
        "mt-7 flex h-[62px] w-full items-center justify-center gap-2 rounded-full",
        "bg-[#4f41a6] text-[17px] font-semibold text-white transition-colors",
        "hover:bg-[#40336e] active:bg-[#2c2150] disabled:cursor-not-allowed disabled:opacity-50"
      )}
    >
      {isLoading ? (
        <>
          <LuLoader size={20} className="animate-spin" />
          <span>{loadingLabel ?? label}</span>
        </>
      ) : (
        <>
          <span>{label}</span>
          {iconRight}
        </>
      )}
    </button>
  );
};

export { VerifyButton };
